export default "__VITE_ASSET__DP_BSi$F__"